import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';

const VARIANT_BASE = {
  band: 'flex items-center gap-3 border-y border-brand-100 bg-brand-50 px-5 sm:px-8',
  card: 'mx-5 flex items-center gap-3 rounded-xl border border-brand-200 bg-brand-50 px-4 shadow-sm sm:mx-8 sm:px-5',
  solid: 'flex items-center gap-3 bg-brand-600 px-5 sm:px-8',
};

const SIZE_PADDING_Y = {
  sm: 'py-2',
  md: 'py-2.5 sm:py-3',
  lg: 'py-3.5 sm:py-4',
};

const ICON_SIZE = {
  sm: 'size-4',
  md: 'size-4 sm:size-5',
  lg: 'size-5',
};

const TEXT_SIZE = {
  sm: 'text-sm',
  md: 'text-sm sm:text-base',
  lg: 'text-sm sm:text-base',
};

const ICON_COLOR = {
  band: 'text-brand-600',
  card: 'text-brand-600',
  solid: 'text-white',
};

const TEXT_COLOR = {
  band: 'text-brand-900',
  card: 'text-brand-900',
  solid: 'text-white',
};

export function InfoBar({
  children,
  variant = 'band',
  size = 'md',
  icon: Icon = Info,
  className,
}) {
  return (
    <div className={cn(VARIANT_BASE[variant], SIZE_PADDING_Y[size], className)}>
      {Icon && (
        <Icon
          className={cn('shrink-0', ICON_SIZE[size], ICON_COLOR[variant])}
          strokeWidth={2.5}
          aria-hidden="true"
        />
      )}
      <p className={cn('font-semibold', TEXT_SIZE[size], TEXT_COLOR[variant])}>
        {children}
      </p>
    </div>
  );
}